module.exports = __webpack_public_path__ + "img/minus.5d1dfa77.svg";